define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Ref",
	"csi/prefs",
	"csi/reflection",
	"csi/resolver"
], function(declare,def,Ref,prefs,reflection,resolver) {

	return declare(Ref, {
		canCopy: function(/*Context*/ctxCopy, /*Heading*/h) {
			return true;
		},

		canPaste: function(/*Context*/ctxCopy, /*Context*/ctxPaste, /*Heading*/h) {
			// summary: must use the same data-sheet type
			var fromRev = ctxCopy.cache.getNode(ctxCopy.getNode().Sheet, true);
			var toRev = ctxPaste.cache.getNode(ctxPaste.getNode().Sheet, true);

			// make sure both are valid nodes to compare
			if (!toRev || !fromRev)
				return false;

			return toRev.$Type == fromRev.$Type;
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return shared custom views for data sheet
			var	dsr = ctx.cache.getNode(ctx.getNode().Sheet, true);
			if (dsr) {
				var	master = ctx.cache.getNode(dsr.Master, true);
				var	cc = reflection.getClassConfig(master.$Type);
				var	subtype = cc.isSiloCustomViewsBySubtype() ? resolver.resolveNode(master.Subtype, true) : null;
				var	keyView = def.getPdfViewKey(master.$Type, subtype ? subtype.$Name : null);

				h.m_relationship = prefs.getStoreRelationship(keyView);
			} else {
				h.m_relationship = null;
			}

			return this.inherited(arguments);
		}
	});
});